import {useHttp} from "./http.hook";
import {CountryExchange} from "../shared/countryExchange";

interface IOpenedFreeSignal {
    id: string,
    country: string,
    ticker: string,
}

interface IDataSaveOpenedFreeSignal {
    message: string,
}

interface IDataGetAll {
    message: string,
    info: IOpenedFreeSignal[]
}

export const useOpenedFreeSignals = () => {

    const {loading, request, error, clearError} = useHttp()

    //сохранение тикера в список тикеров, по которым есть открытые бесплатные сигналы в БД
    const saveOpenedFreeSignal = async (country: CountryExchange, ticker: string) => {
        try {
            const data: IDataSaveOpenedFreeSignal = await request('/api/opened-free-signals/save-one', 'POST', {
                country: country,
                ticker: ticker,
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //удаление тикера из списка тикеров, по которым есть открытые бесплатные сигналы в БД
    const removeOpenedFreeSignal = async (country: CountryExchange, ticker: string) => {
        try {
            const data: IDataSaveOpenedFreeSignal = await request('/api/opened-free-signals/remove-one', 'POST', {
                country: country,
                ticker: ticker
            })
            return data
        } catch (e) {
            throw e
        }
    }


    //получение всех тикеров, по которым есть открытые бесплатные сигналы из БД
    const getAllOpenedFreeSignals = async (country: CountryExchange) => {
        try {
            const data: IDataGetAll = await request('/api/opened-free-signals', 'POST', {
                country: country
            })
            return data
        } catch (e) {
            throw e
        }
    }

    return {
        loading,
        saveOpenedFreeSignal,
        removeOpenedFreeSignal,
        getAllOpenedFreeSignals,
        error,
        clearError
    }
}